import {createAsyncThunk} from "@reduxjs/toolkit";

import {deleteReq, fetchData, fetchDataNew, fetchList} from "../../../../../hook/axios.hook";

const PROFORMS_PATH = "/proforms";

export const fetchProformById = createAsyncThunk("proforms/getProform", async proformId =>
  fetchData(`${PROFORMS_PATH}/get/${proformId}`, "get"),
);

export const fetchForRequestById = createAsyncThunk("proforms/getForRequest", async requestId =>
  fetchData(`${PROFORMS_PATH}/getForRequest/${requestId}`, "get"),
);

export const fetchProforms = createAsyncThunk("proforms/getAllProforms", async () =>
  fetchList(`${PROFORMS_PATH}/getAll`, "get"),
);

export const updateProform = createAsyncThunk("proforms/updateProform", async ({proformId, ...body}) =>
  fetchDataNew(`${PROFORMS_PATH}/update/${proformId}`, "patch", {body}),
);
///add proform
export const addProform = createAsyncThunk("proforms/addProform", async ({requestId, data}) =>
  fetchData(`${PROFORMS_PATH}/add/${requestId}`, "post", data),
);

export const addDocProform = createAsyncThunk("proforms/addDocProform", async ({proformId, data}) =>
  fetchData(`${PROFORMS_PATH}/doc/${proformId}`, "put", data),
);

export const removeDocProform = createAsyncThunk("proforms/removeDocProform", async ({proformId}) =>
  fetchData(`${PROFORMS_PATH}/doc/${proformId}`, "delete"),
);

export const sendProformForControl = createAsyncThunk("proforms/sendForControl", async ({requestId, data}) =>
  fetchData(`${PROFORMS_PATH}/sendForControl/${requestId}`, "post", data),
);

export const approveProform = createAsyncThunk("proforms/approveProform", async proformaId =>
  fetchData(`${PROFORMS_PATH}/approve/${proformaId}`, "patch"),
);

export const rejectProform = createAsyncThunk("proforms/rejectProform", async proformaId =>
  fetchData(`${PROFORMS_PATH}/${proformaId}/reject`, "patch"),
);

export const declineProform = createAsyncThunk("proforms/declineProform", async proformaId =>
  fetchData(`${PROFORMS_PATH}/decline/${proformaId}`, "patch"),
);

export const sendProformToFactory = createAsyncThunk("proforms/sendProformToFactory", async requestId =>
  fetchData(`${PROFORMS_PATH}/sendToFactory/${requestId}`, "patch"),
);

export const removeProformFromControl = createAsyncThunk("proforms/removeFromControl", async proformaId =>
  fetchData(`${PROFORMS_PATH}/removeFromControl/${proformaId}`, "patch"),
);

export const deleteProform = createAsyncThunk("proforms/delete", async proformaId =>
  fetchData(`${PROFORMS_PATH}/remove/${proformaId}`, "delete"),
);

//proform approvals
const PROFORM_APPROVALS_PATH = `${PROFORMS_PATH}/approvals`;

export const fetchForCurrentApproval = createAsyncThunk("proforms/approvals/getForCurrent", async () =>
  fetchList(`${PROFORM_APPROVALS_PATH}/getForCurrent`, "get"),
);

export const fetchForUserApprovals = createAsyncThunk("proforms/approvals/getForUser", async userId =>
  fetchList(`${PROFORM_APPROVALS_PATH}/getForUser/${userId}`, "get"),
);

export const addDisapprovementReason = createAsyncThunk(
  "proforms/approvals/addDisapprovementReason",
  async ({approvalId, data}) =>
    fetchDataNew(`${PROFORM_APPROVALS_PATH}/addReason/${approvalId}`, "post", {rawBody: data, noMessage: true}),
);

export const deleteDisapprovementReasons = createAsyncThunk(
  "proforms/approvals/removeReason",
  async ({approvalId, reasonIds}) => deleteReq(`${PROFORM_APPROVALS_PATH}/removeReason/${approvalId}`, {reasonIds}),
);

export const declineProformApproval = createAsyncThunk(
  "proforms/approvals/declineProformApproval",
  async ({approvalId, data}) => fetchData(`${PROFORM_APPROVALS_PATH}/decline/${approvalId}`, "patch", data),
);

export const addProformApproval = createAsyncThunk(
  "proforms/approvals/addProformApproval",
  async ({approvalId, data, withoutError}, {rejectWithValue}) => {
    return fetchDataNew(`${PROFORM_APPROVALS_PATH}/approve/${approvalId}`, "patch", {
      rawBody: data,
      rejectWithValue,
      withoutError,
    });
  },
);

//rejected proforms
export const fetchAllRejectedProforms = createAsyncThunk(
  "proforms/fetchAllRejectedProforms",
  async ({params} = {}, {rejectWithValue, signal}) =>
    fetchDataNew(`${PROFORMS_PATH}/rejected/`, "get", {params, rejectWithValue, signal}),
);
export const fetchRejectedProformsFilters = createAsyncThunk(
  "proforms/fetchRejectedProformsFilters",
  async ({params} = {}, {rejectWithValue, signal}) =>
    fetchDataNew(`${PROFORMS_PATH}/rejected/filters`, "get", {params, rejectWithValue, signal}),
);
export const fetchRejectedProform = createAsyncThunk(
  "proforms/fetchRejectedProform",
  async (rejectionId, {rejectWithValue, signal}) =>
    fetchDataNew(`${PROFORMS_PATH}/rejected/${rejectionId}`, "get", {rejectWithValue, signal}),
);
export const unblockProform = createAsyncThunk(
  "proforms/unblockProform",
  async ({rejectionId}, {rejectWithValue, signal}) => {
    return fetchDataNew(`${PROFORMS_PATH}/rejected/${rejectionId}`, "patch", {rejectWithValue, signal});
  },
);
